import { useQuery } from '@tanstack/react-query';
import { fetchWeeklySummary } from '../api/attendanceApi';
import { attendanceKeys } from './attendanceKeys';

export function useWeeklySummary(weekStart: string | undefined) {
  return useQuery({
    queryKey: attendanceKeys.weeklySummary(weekStart),
    queryFn: () => fetchWeeklySummary(weekStart as string),
    enabled: !!weekStart,
    staleTime: 30_000,
  });
}
